//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";

//css
import styled from "styled-components"

// component
import MyCoupon from "./components/MyCoupon"

export default function MyCouponPage() {

    return (
        <MyCoupon/>
    );
  }

